import React from 'react'

import { Icon } from '../Icon'

interface LabelIconProps {
  className?: string
}

export const LabelIcon = React.memo(({ className }: LabelIconProps) => (
  <Icon
    size="16"
    viewBox="0 0 16 16"
    preserveAspectRatio="xMidYMid meet"
    fill="none"
    color="currentColor"
    className={className}
  >
    <path d="M1.9157 14.4657C1.91515 14.3339 1.91461 14.4285 1.9157 14.4657V14.4657Z" fill="#EEEEEE" />
    <path d="M14.0836 14.5689C14.0853 14.5328 14.0842 14.3186 14.0836 14.5689V14.5689Z" fill="#EEEEEE" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.72719 1.90292H7.27264V3.35747H8.72719V1.90292ZM6.18173 0.812012V4.44837H9.81809V0.812012H6.18173Z"
      fill="#2734F8"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.1334 4.5335H3.86678V14.5779H12.1334V4.5335ZM2.66678 3.3335V15.7779H13.3334V3.3335H2.66678Z"
      fill="black"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.96989 12.0099C6.41122 12.1585 7.14136 12.3334 7.99988 12.3334C8.8584 12.3334 9.58855 12.1585 10.0299 12.0099C9.97525 11.6988 9.85497 11.3346 9.63867 11.0197C9.34324 10.5897 8.85627 10.2266 7.99988 10.2266C7.1435 10.2266 6.65652 10.5897 6.36109 11.0197C6.1448 11.3346 6.02451 11.6988 5.96989 12.0099ZM5.37201 10.3403C5.87658 9.60579 6.72293 9.02661 7.99988 9.02661C9.27683 9.02661 10.1232 9.60579 10.6278 10.3403C11.1106 11.0431 11.2665 11.862 11.2665 12.4001V12.7709L10.9349 12.9367C10.499 13.1546 9.37636 13.5334 7.99988 13.5334C6.62341 13.5334 5.50073 13.1546 5.06489 12.9367L4.73322 12.7709V12.4001C4.73322 11.862 4.88916 11.0431 5.37201 10.3403Z"
      fill="black"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.00019 8.53346C8.51565 8.53346 8.93352 8.1156 8.93352 7.60013C8.93352 7.08466 8.51565 6.6668 8.00019 6.6668C7.48472 6.6668 7.06685 7.08466 7.06685 7.60013C7.06685 8.1156 7.48472 8.53346 8.00019 8.53346ZM8.00019 9.73346C9.17839 9.73346 10.1335 8.77834 10.1335 7.60013C10.1335 6.42192 9.17839 5.4668 8.00019 5.4668C6.82198 5.4668 5.86685 6.42192 5.86685 7.60013C5.86685 8.77834 6.82198 9.73346 8.00019 9.73346Z"
      fill="black"
    />
  </Icon>
))
